import {isPortrait} from "./util";

export var errorTimeout = {
    title: "Error",
    description: `Sorry the tour ran into an issue and could not complete.`
};

export const tourRestarted = {
    title: "Tour restarted",
    description: `We've detected your browser has been resized, which means some functionality of the site will have changed. Due to this, the <b>tour will now be restarted</b> to handle these differences.`
};

export const intro = {
    title: "S&#8209;Map Online tour",
    description: "This is the map page, which consists of a main map window, surrounded by a series of panels and controls which enable you to view the map, move around the map and see more detail, query the S&#8209;Map data, view an S&#8209;Map report and print a S&#8209;Map soil map.",
};

export const introTablet = {
    title: "S&#8209;Map Online tour",
    description: `This is the map page, which consists of a main map window, and a series of buttons and controls. These enable you to move around the map and see more detail, query the S&#8209;Map data, view an S&#8209;Map report and print a S&#8209;Map soil map.`
};

export const introMobile = {
    title: "S&#8209;Map Online tour",
    description: `This is the map page, which consists of a main map window, and a series of buttons and controls. These enable you to move around the map and see more detail, query the S&#8209;Map data, view an S&#8209;Map report and print a S&#8209;Map soil map.`
};

export const mainButtonsTablet = {
    title: "Panels and windows",
    description: `These large buttons open panels or windows which contain information relating to
    what S&#8209;Map data is visible on the map and controls to change the visible map layers. You can also
    perform a search.`
};



export const mainButtonsMobile = () => {
    const descriptionPosition = isPortrait() ? 'top' : 'left';
    return {
        title: "Panels and windows",
        description: `These large buttons at the ${descriptionPosition} open panels or windows which contain information relating to what S&#8209;Map data is visible on the map and controls to change the visible map layers. You can also perform a search.`,
        position: isPortrait() ? 'bottom-center' : 'right-center'
    };
};

export const searchAndLayers = {
    title: "Search and layers",
    description: `The panels contain information relating to what S&#8209;Map data is visible on the map,  controls to change the visible map layers. You can also perform a search.`,
};

export const search = {
    title: "Search",
    description: `Use the the search tool to find a place, address or enter geographic coordinates.`
};

export const mapNav = {
    title: "Map navigation",
    description: "You can use the +/- buttons or your mouse wheel to zoom in and out of the map. Click and drag map to pan. A new map will appear.",
};

export const mapNavTouch = {
    title: "Map navigation",
    description: `You can use the +/- buttons or your mouse wheel to zoom in and out of the map. Touch and drag map to
    pan. A new map will appear.`
};

export const changingLayers = {
    title: "Changing map layers",
    description: `Map layers are split into three categories - basemaps, soil layers and context layers.
            Clicking on these layers will toggle them on/off and information relating to what they show will be displayed in the metadata and legend panels.`,
};

export const changingLayersTouch = {
    title: "Changing map layers",
    description: `Map layers are split into three categories - basemaps, soil layers and context layers. Tapping on
    these layers will toggle them on/off and information relating to what they show will be displayed in the metadata
    and legend panels. `
};

export const reports = {
    title: "Reports",
    description: `These controls allow you to generate a S&#8209;Map soil report based on a point, an area or a predefined extent. `
};

export const reportsMenuMobile = {
    title: "Reports",
    description: `These controls allow you to generate a soil report based on an area or a predefined extent. `
};

export const reportingMobile = {
    title: "Reporting",
    description: `You can click on the map to get a soil summary for a specific location`
};

export const reportsButtonMobile = {
    title: "Reports button",
    description: `This button opens reporting controls...`
};

export const soilSummary = {
    title: "Soil summary",
    description: `For example, to generate and view a report for a specific location, click on the "Soil summary" button...`,
};

export const soilSummaryPt2 = {
    title: "Soil summary",
    description: `...then click on a location on the map.`,
};

export const soilSummaryPt2Touch = {
    title: "Soil summary",
    description: `...then tap on a location on the map.`,
};

export const soilSummaryPt3 = (desktop: boolean) => {
    return {
        title: "Soil summary",
        description: ` Basic report information will appear in this panel. Additional soil data is available by
        ${desktop ? 'clicking' : 'tapping'} the Soil Map Unit Factsheet link, which opens the report window, or by
        ${desktop ? 'clicking' : 'tapping'} on a soil sibling to view / download a factsheet. Click the BACK button to
         choose another reporting option. `,
    };
};

export const smuReport = (desktop: boolean) => {
    return {
        title: "Soil map unit factsheet",
        description: `The Soil Map Unit Factsheet window contains detailed information, including charts and tables about
    the various soil properties of that map unit, including texture, permeability and available water. This report can
    be shared or printed by ${desktop ? 'clicking' : 'tapping'} the buttons at the top.`
    };
};

export const areaReportMobile = {
    title: "Area report",
    description: `Reports can be generated for an area defined by you or by choosing a predefined
            area such as a LINZ NZ land parcel or Maori land block. `
};

export const areaReport = {
    title: "Area report",
    description: `Reports can also be generated for an area defined by you or by choosing a predefined
            area such as a LINZ NZ land parcel or Maori land block. `
};

export const predefinedFeatures = {
    title: "Predefined feature reports",
    description: `For this example, generating a report based on a LINZ parcel will be demonstrated.`
};

export const linzParcel = {
    title: "LINZ Parcel example",
    description: `The LINZ parcel you chose will be displayed on the map, and the report will be displayed in the Soil Report panel.`,
};

export const pdfMaps = {
    title: "PDF Maps",
    description: `High quality PDF maps can be generated using the Print tool.`,
};

export const pdfMapPane = {
    title: "PDF Maps",
    description: `The print window allows you to choose a title for your printed map, paper size and
            orientation, and map scale. The extent of the map that will be printed is shown by the semi-transparent rectangle.`
};

export const conclusion = {
    title: "Conclusion",
                    // note, &#8209; is a non-breaking hyphen
    description: `<p>This concludes your introductory tour.
                More detailed help is available on the <a href="/help/first-time-here" target="_blank">first time here</a> page.
                </p>
                <p>
                Enjoy exploring New Zealand soils with S&#8209;Map Online!
                </p>`,
};
